import React, { Component } from 'react';

export default class EditLeaseImei extends Component {
  state = {
    isEdit: false,
    value: this.props.value,
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.value !== this.props.value) {
      this.setState({ value: this.props.value });
    }
  }

  handleChangeInput = (e) => {
    this.setState({ value: e.target.value });
  };

  handleChangeSelect = (e) => {
    this.setState({ value: e.target.value });
  };

  startEdit = () => {
    this.setState({ isEdit: true });
  };

  cancelEdit = () => {
    this.setState({ value: this.props.value, isEdit: false });
  };

  handleSave = () => {
    this.props.save(this.props.id, this.props.name, this.state.value);
    this.cancelEdit();
  };

  render() {
    const { value, isEdit } = this.state;
    if (isEdit) {
      return (
        <td
          style={{
            padding: '4px 8px',
            width: '210px',
            minWidth: '210px',
            minHeight: '76px',
            height: '76px',
          }}
        >
          <input
            className="form-control"
            value={value}
            onChange={this.handleChangeInput}
            style={{ height: '28px', padding: '4px 12px' }}
          />

          <button
            style={{
              height: '28px',
              fontSize: '12px',
              padding: '5px 12px 4px',
              marginTop: '10px',
            }}
            onClick={this.handleSave}
            className="btn btn-primary mar-r"
          >
            Save
          </button>
          <button
            style={{
              height: '28px',
              fontSize: '12px',
              padding: '5px 12px 4px',
              marginTop: '10px',
            }}
            onClick={this.cancelEdit}
            className="btn btn-default"
          >
            Cancel
          </button>
        </td>
      );
    }

    return (
      <td
        style={{
          width: '210px',
          minWidth: '210px',
          minHeight: '76px',
          height: '76px',
        }}
      >
        {this.props.value}
        <img
          style={{
            cursor: 'pointer',
            width: '14px',
            height: '14px',
            marginTop: '-2px',
            marginLeft: '20px',
          }}
          onClick={this.startEdit}
          src="/images/pen-to-square-regular.svg"
          alt="edit"
        />
      </td>
    );
  }
}
